import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { allProfilesCategories } from "../data/CategoriesData"
import { editModiratorsData } from "../hooks/apiAxios"

import { handleImageChange } from "../utilities/handleFunctions/HandelImageChange"
import { emailValidation, mobileValidation } from "../utilities/validations/inputsValidations"
import { toast } from "react-toastify";

export function ModiratorData({ id, firstName, lastName, email, mobilePhone, role, userImage, UserSampleImg }) {
    const [errorMessage, setErrorMessage] = useState('');
    const [image, setImage] = useState(userImage);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [loading, setLoading] = useState(false);
    const [dataUpdate, setDataUpdate] = useState(false);
    const roles = ["superAdmin", "admin", "moderator"]


    async function onSubmitModirator(formData) {
        setLoading(true);

        try {
            const response = await editModiratorsData(id, formData);

            if (response.data.isSuccess) {
                setDataUpdate(true);
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.warn("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }


    return (
        <div id={`edit-moderator${id}`}
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="moderatorEditForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="moderatorEditForm">{firstName}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">

                        <form className='d-flex shadow mx-auto gap-2 text-start bg-white pe-5 ps-3 pb-4 rounded'
                            onSubmit={handleSubmit(onSubmitModirator)}>


                            <div className="profile-image-container position-relative my-auto ms-2">
                                <img className="profile-image mx-auto"
                                    crossOrigin="anonymous"
                                    src={image ? image : UserSampleImg} alt={`${role}_${id}_Img`} />
                                <h6 className="profile-change-text border text-center">تغيير الصورة</h6>

                                <input
                                    // disabled
                                    className=" opacity-0 profile-image-input"
                                    type="file"
                                    accept="image/jpeg"
                                    onChange={(e) => handleImageChange(e, setValue, setImage,
                                        setErrorMessage)}
                                />
                            </div>

                            <div className="d-flex flex-column col-8 mx-auto my-5 gap-3">


                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">الاسم الأول</span>
                                    <input className={`form-control ${errors.firstName && "border border-danger"}`}
                                        type="text"
                                        placeholder="الاسم الأول"
                                        onChange={(e) => { setValue("firstName", e.target.value) }}
                                        defaultValue={firstName}
                                        {...register("firstName", { required: true, minLength: 3 })} />
                                    {errors.firstName && <p className='errors-msg'>الاسم مطلوب أكبر من ٣ أحرف</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">الاسم الأخير</span>
                                    <input className={`form-control ${errors.lastName && "border border-danger"}`}
                                        type="text"
                                        placeholder="الاسم الأخير"
                                        onChange={(e) => { setValue("lastName", e.target.value) }}
                                        defaultValue={lastName}
                                        {...register("lastName", { required: true, minLength: 3 })} />
                                    {errors.lastName && <p className='errors-msg'>الاسم مطلوب أكبر من ٣ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >البريد</span>
                                    <input className='form-control' type="text" placeholder="البريد الالكتروني" defaultValue={email} {...register("email", { required: true, pattern: emailValidation })} />
                                    {errors.email && <p className='errors-msg'>أدخل البريدالالكتروني</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >رقم الجوال</span>
                                    <input className='form-control text-start' type="tel" placeholder="05xxxxxxxx" defaultValue={mobilePhone} {...register("mobilePhone", { required: true, pattern: mobileValidation })} />
                                    {errors.mobilePhone && <p className='errors-msg'>أدخل رقم الجوال الصحيح</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >المسؤولية</span>
                                    <select className='form-select text-start'>
                                        <option value={role}>{role}</option>
                                        {roles
                                            .filter(oneRole => oneRole !== role)
                                            .map((oneRole, index) => (
                                                <option key={index} value={oneRole}>
                                                    {oneRole}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >إعادة تعيين كلمة السر</span>
                                    <input className='form-control'
                                        type="password" placeholder="كلمةالسر"
                                        name='password'
                                        onChange={e => setValue("password", e.target.value)}

                                    // {...register("password", { minLength: 8, maxLength: 16 })}
                                    />
                                    {errors.password && <p className='errors-msg'>كلمة المرور تكون من ٨-١٠ أحرف</p>}
                                </div>
                            </div>
                            <button
                                className='btn-masar btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0 ms-5'
                                type="submit">
                                {loading &&
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                }
                                حفظ
                            </button>

                            {/* <button className="btn-masar btn-dark-orange text-white p-1 rounded position-absolute top-0 end-0 m-2">
                                <FontAwesomeIcon icon={faEraser} />
                            </button> */}
                        </form>

                        {
                            errorMessage &&
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {errorMessage}
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        }

                        {
                            dataUpdate &&
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                تم تحديث ملفك بنجاح .. شكرا لك
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}


export function ProfileModify({ id, imgSrc, imgCat, description }) {
    return (
        <div id={`profile-works-details-${id}`}
            className="modal fade"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="profileDetailsLabel"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="profileDetailsLabel">التفاصيل</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <img crossOrigin="anonymous" className='w-50 rounded my-2 text-center'
                            src={imgSrc ? imgSrc : "/images/Profile-Sample0.jpg"} alt='profile avatar' />
                        <div className="mt-2">
                            <label>التصنيف</label>
                            <select className='form-select form-select-sm' >
                                <option value={imgCat}>{imgCat}</option>
                                {allProfilesCategories
                                    .filter(category => category.ar !== imgCat)
                                    .map((category, index) => (
                                        <option key={index} value={category.en}>
                                            {category.ar}
                                        </option>
                                    ))}
                            </select>
                        </div>
                        <div className="w-100 mt-2">
                            <label htmlFor="offerFile">ملف جديد</label>
                            <input className="form-control form-control-sm mb-4" type="file" id="offerFile" accept=".pdf" />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
